import { Link } from "react-router-dom";

import { useCommonStore } from "@stores/index";

export const NotFoundPage = () => {
  const isAuth = useCommonStore(({ isAuth }) => isAuth);

  return (
    <div className="mt-6 flex min-h-[calc(100dvh_-_152px)] flex-col items-center rounded-t-2xl bg-white-100 px-4 pt-[118px] md:rounded-b-lg md:rounded-t-3xl md:pt-[162px]">
      <h1 className="text-[128px]/[148px] font-bold text-primary-300 md:text-[196px]/[196px]">
        404
      </h1>
      <div className="pt-2 text-600 font-bold text-black-100">
        Page not found
      </div>
      <div className="max-w-[403px] pt-2 text-center text-button font-bold text-black-70 md:text-300">
        Sorry, the page you are looking for does not exist or may have been
        moved.
      </div>
      <Link
        to="/"
        className="mt-6 flex h-14 items-center justify-center gap-x-2 rounded-lg bg-primary-100 px-8 text-button text-white-100 transition-opacity duration-300 hover:opacity-80"
      >
        {isAuth ? "Back to Dashboard" : "Back to Login"}
      </Link>
    </div>
  );
};
